(() => {
  const control=document.querySelector('[data-metal-finishes]');
  if(!control||control.dataset.ready)return;
  control.dataset.ready='true';
  const dialog=control.querySelector('[data-metal-guide]');
  const opener=control.querySelector('[data-metal-guide-open]');
  opener.addEventListener('click',()=>dialog.showModal());
  control.querySelector('[data-metal-guide-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>opener.focus());
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  const syncFinish=()=>{const selected=control.querySelector('input[type="radio"]:checked');if(selected)control.querySelector('[data-metal-selected]').textContent=selected.value;};
  control.addEventListener('change',syncFinish);
  // Browsers restore form values after pageshow when returning from checkout.
  window.addEventListener('pageshow',()=>setTimeout(syncFinish,0));
  syncFinish();
  const root=control.closest('[data-product-handle]');
  // Keep the app-owned pricing controls intact, above finish and upload choices.
  const form=control.closest('form');
  const positionQuantity=()=>{
    const tier=root?.querySelector('.cl-po--wrapper');
    const mount=tier?.closest('.inject');
    if(!mount||!form?.contains(mount))return false;
    if(mount.nextElementSibling!==control)control.before(mount);
    return true;
  };
  if(!positionQuantity()){
    const observer=new MutationObserver(()=>{if(positionQuantity())observer.disconnect();});
    observer.observe(form,{childList:true,subtree:true});
    setTimeout(()=>observer.disconnect(),30000);
  }
  const note=document.createElement('p');note.className='pp-metal-concepts';note.textContent='Rubicer customer work and illustrative design concepts. Your keyrings are made with your own artwork.';
  root?.querySelector('[data-product-images]')?.append(note);
})();
